import { forwardRef } from 'react';
import { type ColorlessIconProps, type IconSize, SVGContainer } from '@direct-frontend/components';

const IconTruthfulLabel44 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTruthfulLabel44(props, ref) {
    return (
        <SVGContainer
            {...props}
            width={props.size}
            height={props.size}
            viewBox={`0 0 ${props.size} ${props.size}`}
            ref={ref}
        >
            <path
                d="M11.8599 0H32.1401C36.2563 0 37.7599 0.432294 39.2636 1.2405C40.7484 2.0299 41.9701 3.2516 42.7595 4.73644C43.5677 6.24007 44 7.7249 44 11.8599V32.1401C44 36.2563 43.5677 37.7599 42.7595 39.2636C41.9701 40.7484 40.7484 41.9701 39.2636 42.7595C37.7599 43.5677 36.2751 44 32.1401 44H11.8599C7.7437 44 6.24007 43.5677 4.73644 42.7595C3.2516 41.9701 2.0299 40.7484 1.2405 39.2636C0.432294 37.7787 0 36.2751 0 32.1401V11.8599C0 7.7437 0.432294 6.24007 1.2405 4.73644C2.0299 3.2516 3.2516 2.0299 4.73644 1.2405C6.24007 0.432294 7.7437 0 11.8599 0Z"
                fill="#EAE60E"
            />
            <path
                d="M32.9857 8.92791C34.1323 8.92791 35.072 9.86768 35.072 11.033V16.2393H39.4326V11.033C39.4326 7.46187 36.5381 4.56738 32.9857 4.56738H27.7606V8.94671H32.9857V8.92791Z"
                fill="#63666A"
            />
            <path
                d="M35.072 32.9859C35.072 34.1324 34.1323 35.0721 32.9857 35.0721H27.7606V39.4327H32.9857C36.5381 39.4327 39.4326 36.5382 39.4326 32.9859V27.7607H35.072V32.9859Z"
                fill="#63666A"
            />
            <path
                d="M8.90899 11.033C8.90899 9.86768 9.84876 8.92791 10.9953 8.92791H16.2204V4.54858H10.9953C7.42416 4.56738 4.54846 7.46187 4.54846 11.0142V16.2205H8.90899V11.033Z"
                fill="#63666A"
            />
            <path
                d="M11.017 35.0909C9.87049 35.0909 8.93072 34.1512 8.93072 33.0047V27.7795H4.57019V33.0047C4.58899 36.557 7.46468 39.4515 11.017 39.4515H16.2421V35.0909H11.017Z"
                fill="#63666A"
            />
            <path
                d="M19.4906 32.4597L10.1681 23.1372L13.2505 20.0547L19.4906 26.2948L30.7678 15.0176L33.8503 18.1L19.4906 32.4597Z"
                fill="#63666A"
            />
        </SVGContainer>
    );
});

export const IconTruthfulLabel = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconTruthfulLabel(props, ref) {
    const { role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size: props.size || ('44' as IconSize),
        ref,
        role,
        colorless: true,
    } as const;

    return <IconTruthfulLabel44 {...iconProps} />;
});
